import { useEffect, useState } from 'react';
import { getFilterValue, useDoctorInsuranceFilter } from '@medifind/zustand';
import styles from './InsuranceNotKnownDisclaimer.module.scss';

const InsuranceNotKnownDisclaimer = () => {
  return (
    <div className={styles['disclaimer__container']}>
      <div className={styles['disclaimer__text']}>
        We can't determine if the doctors below this point have the selected insurance, you may need to call them to confirm they accept
        your insurance.
      </div>
    </div>
  );
};
const useInsuranceNotKnownDisclaimerPosition = ({ featuredResults = [], results }) => {
  const [insuranceNotKnownDisclaimerPosition, setInsuranceNotKnownDisclaimerPosition] = useState(-1);
  const doctorInsurance = useDoctorInsuranceFilter(getFilterValue);

  useEffect(() => {
    if (results && featuredResults && doctorInsurance?.length > 0) {
      const featuredI = featuredResults.findIndex(
        (doctor) => doctor?.issuers?.map((d) => d.personifyId).findIndex((ins) => doctorInsurance.includes(ins)) === -1,
      );
      const resultsI = results.findIndex(
        (doctor) => doctor?.issuers?.map((d) => d.personifyId).findIndex((ins) => doctorInsurance.includes(ins)) === -1,
      );
      let i;
      if (featuredI !== -1 && resultsI === -1) i = resultsI;
      else if (featuredI !== -1) i = featuredI;
      else if (featuredI === -1 && resultsI !== -1) {
        i = resultsI;
        if (i !== -1) i += featuredResults.length;
      }

      setInsuranceNotKnownDisclaimerPosition(i);
    } else {
      setInsuranceNotKnownDisclaimerPosition(-1);
    }
  }, [results, doctorInsurance]);

  return insuranceNotKnownDisclaimerPosition;
};
export { InsuranceNotKnownDisclaimer as default, InsuranceNotKnownDisclaimer, useInsuranceNotKnownDisclaimerPosition };
